/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Print_BtnInputs */

const vi_lot_label_print_btn = /** @type {(inputs: Lot_Label_Print_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu`)
};

/**

* @param {Lot_Label_Print_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_print_btn = /** @type {((inputs?: Lot_Label_Print_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Print_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_print_btn(inputs)
});